import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Configs, GenericConfigType } from '../../../../../interfaces/src/lib/interfaces/index';
import { v4 as uuidv4 } from 'uuid';
import { loadFromSessionStorage } from '../../genericUtils/genericUtils';

const initialState: GenericConfigType = {
  configs: {
    myPrivateAreaConfig: {
      myMscAreaBasePath: '',
      labCDLabels: [],
      lightLoginForbiddenPriceTypes: [],
      myPrivateAreaHomepage: '',
      loginRedirects: [],
      notAllowedPriceTypes: [],
      bookingStatusLabels: [],
      lightLoginForbiddenAgencyCode: [],
      excursionActivityToIcon: [],
      wciOpensOn: 0,
      wciClosesOn: 0,
      lightLoginPassengerMinimumAge: 0,
      insuranceEurope: [],
      promoThreshold: 0,
      smallKidAgeThreshold: 0,
    },
    b2cCommerceConfig: {
      currencySymbol: '',
      currencyCode: '',
      enableDecimalInPrice: true,
      enableDecimalOnlyIfDifferentFrom0: false,
      decimalSeparator: '',
      thousandsSeparator: '',
      pricePrecision: 0,
      strikethrough: [],
      strikethroughDiscountCodes: [],
      dateFormat: '',
      locale: '',
      languageCode: '',
      languageCode3Char: '',
      countryCode: '',
      countryCodeISO3: '',
      timeFormat: '',
      shipMapping: {},
      itineraryImgDomain: '',
      enableEmbarkAndDisembarkExcursions: false,
      priceCurrencyOrder: '',
      dictionary: [],
      contentFragmentInfo: {
        contentFragmentsRoot: '',
        shipContentFragmentsRoot: '',
        portContentFragmentsRoot: '',
      },
      languageMapping: [],
      adultAgePerMarketMapping: [],
      noPostCodeCountries: [],
      algoliaApiKey: '',
      algoliaApplicationId: '',
      cookieComplianceJson: '',
      strictlyNecessary: [],
    },
    conversationID: loadFromSessionStorage('conversationID', ''),
    cruiseSearchConfig: {
      searchDaysBeforeDeparture: 0,
      hitsPerPage: 0,
      maxTotalNumberOfGuests: 0,
      tags: [],
      ribbons: [],
      roundUpPrices: false,
      itineraryImages: {
        itineraryCodesImagesConfig: {},
        portOfCallsImagesConfig: {},
        areaImagesConfig: {},
        fallbackImagesConfig: [],
      },
      canvas: [],
    },
    bookingFunnelConfig: {
      hiddenItemsCodes: [],
      daysToDisplayDocumentAndEmergency: 0,
      allowedPaymentsMethods: [],
      allowedCardNetworks: [],
      allowedPaymentButtons: [],
      allowedPaymentsMethodsDeposit: [],
      allowedCardNetworksDeposit: [],
      allowedPaymentButtonsDeposit: [],
      paymentButtonMerchantName: '',
      paymentButtonAmountPaymentLabel: '',
      allowedCardNetworksPaymentButton: [],
      daysToHideFullPayment: undefined,
      enableHoldOption: true,
      daysToHideHoldOption: null,
      offersRibbonConfig: [],
      hideHotelServiceCharges: false,
      hidePortTaxes: false,
      enableApiPaymentKlarna: false,
      enableDataByLoginPrefill: false,
    },
    editorialComponentsConfig: {
      carouselNextIconLabel: '',
      carouselPrevIconLabel: '',
      accordionOpenIconLabel: '',
      accordionCloseIconLabel: '',
      overwriteExistingLabelsForCarouselLabels: false,
      overwriteExistingLabelsForAccordionLabels: false,
      overwriteWishlistAutorTooltip: false,
      wishlistIconTooltipWhenAdded: '',
      wishlistIconTooltipWhenNotAdded: '',
    },
    siteTypeConfig: {
      siteType: '',
    },
    azureB2CConfig: {
      signUpUserFlow: '',
      loginUserFlow: '',
      clientId: '',
      tenantName: '',
      resetPasswordUserFlow: '',
      authorityBaseUrl: '',
    },
  },
};

const genericConfigSlice = createSlice({
  name: 'genericConfigs',
  initialState,
  reducers: {
    setConfigs: (state: GenericConfigType, action: PayloadAction<Configs>) => {
      // Salva il conversationID esistente prima di sovrascrivere lo state
      const existingConversationID = state.configs.conversationID;
      state.configs = action.payload;
      // Ripristina il conversationID esistente o genera uno nuovo se non esiste
      state.configs.conversationID =
        existingConversationID || action.payload.conversationID || uuidv4();
    },
    setConversationID: (state: GenericConfigType) => {
      state.configs.conversationID = uuidv4();
    },
  },
});

export const { setConfigs, setConversationID } = genericConfigSlice.actions;
export const genericConfigReducer = genericConfigSlice.reducer;
